import { useEffect, useState } from "react";

import { appCRUD } from "../../../actions/app";
import { TableShared } from "../../../shared";
import { char } from "../../../utils";
import { Button, Dropdown, Space, Tooltip } from "antd";
import { MoreOutlined, EyeOutlined } from "@ant-design/icons";
import { useNotification } from "../../../utils/notificationProvider";
import { useNavigate } from "react-router-dom";


export const DepartmentContent = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0);
  const [value, setValue] = useState("");
  const [index, setIndex] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortType, setSortType] = useState("");
  const openNotification = useNotification();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .loadDepartment(postsPerPage, nextPage, value, "name")
        .then((resp) => {
          setData(resp.data.results);
          setCount(resp.data.count);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Sorry...!
              <br />
              {error.message}
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500);
  }, [page, postsPerPage, value, index, nextPage]);

  const defaultColumns = [
    {
      key: "sn",
      title: "#",
      dataIndex: "sn",
      fixed: true,
      width: 50,
    },
    {
      key: "code",
      title: "Department Code",
      dataIndex: "code",
      sortable: true,
      width: 100,
    },
    {
      key: "name",
      title: "Department Name",
      dataIndex: "name",
      sortable: true,
      width: 200,
      render: (text) => (
        <Tooltip title={text}>
          {text.length > 60 ? `${text.slice(0, 60)}...` : text}
        </Tooltip>
      ),
    },
    {
      key: "status",
      title: "Status",
      dataIndex: "status",
      sortable: true,
      width: 80,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 50,
      render: (record) => (
        <Dropdown
          menu={{
            items: [
              {
                label: "View",
                key: "view",
                icon: <EyeOutlined />,
              },
            ],
            onClick: (event) => {
              switch (event.key) {
                case "view":
                  navigate("/school", {
                    state: { page: "details", dataId: record.id },
                  });
                  break;
                default:
              }
            },
          }}
          placement="bottomRight"
          arrow={{ pointAtCenter: true }}
        >
          <Space>
            <Button type="dashed" icon={<MoreOutlined />} size={"small"} />
          </Space>
        </Dropdown>
      ),
    },
  ];

  const dataItem = data?.map((dt, i) => ({
    id: dt.id,
    sn: i + 1,
    code: dt.code ? dt.code : "N/A",
    name: dt.name ? char.toTitleCase(dt.name) : "N/A",
    status: dt?.is_active ? (
      <span className="badge badge-soft-success badge-border">{"Active"}</span>
    ) : (
      <span className="badge badge-soft-danger badge-border">{"Inactive"}</span>
    ),
  }));

  const handleDepartment = () => {
    setLoading(true);
    setTimeout(() => {
      appCRUD
        .addDepartment()
        .then(() => {
          openNotification(
            "success",
            "Success",
            <>
              🎉 Congratulations...!
              <br />
              Department has been successfully saved...!
            </>
          );
          setIndex(index + 1);
        })
        .catch((error) => {
          openNotification(
            "error",
            "Error",
            <>
              Oops...!
              <br />
              Something went wrong. Please try again.
            </>
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }, 1000);
  };

  const button = (
    <button
      className="btn btn-primary bg-gradient btn-border"
      onClick={handleDepartment}
    >
      <span className="bi bi-plus-circle la-lg"></span> &nbsp; New Department
    </button>
  );

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-12">
            <p className="h6 fs-18 fw-bold text-dark">Departments</p>
          </div>
          <hr className="mt-3" />
        </div>
        <TableShared
          loading={loading}
          data={dataItem}
          setData={setData}
          page={page}
          setPage={setPage}
          count={count}
          postsPerPage={postsPerPage}
          setePostPerPage={setePostPerPage}
          setNextPage={setNextPage}
          value={value}
          setValue={setValue}
          defaultColumns={defaultColumns}
          button={button}
          link={"#"}
          showButton={true}
          sortColumn={sortColumn}
          setSortColumn={setSortColumn}
          sortType={sortType}
          setSortType={setSortType}
          setLoading={setLoading}
        />
      </div>
    </>
  );
};
